export enum SwapStatus {
  EXECUTED = 'EXECUTED',
  PROPOSED = 'PROPOSED',
  INITIATED = 'INITIATED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
}
